'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import ContextComponent from '../../../global/components/ContextComponent';
import PinterestPinIcon from '../../../global/components/Pinterest/PinterestPinIcon';
import PdpFacebookIcon from './PdpFacebookIcon';
import PdpEmailIcon from './PdpEmailIcon';
import PdpPrintIcon from './PdpPrintIcon';
import { MediaQuery, queries } from 'dibs-media-query';
import connectToStores from 'fluxible-addons-react/connectToStores';
import PdpUiStore from '../../stores/PdpUiStore';

import enabler from '../../../global/utils/enabler.es';

class PdpSocialIcons extends ContextComponent {
    _getPrintIcon() {
        const { printIcon, context } = this.props;

        if (printIcon) {
            return (
                <MediaQuery query={queries.xl}>
                    <PdpPrintIcon context={context} />
                </MediaQuery>
            );
        }

        return null;
    }

    render() {
        const props = this.props;
        const {
            socialData,
            iconType,
            onPinterestPin,
            pinterestConnectAccounts,
            viewer,
            user,
            itemData,
            isPinterestModalShown,
        } = props;

        return (
            <div className="pdp-social-icons">
                <PinterestPinIcon
                    connectAccountsModalIsOpen={isPinterestModalShown}
                    url={socialData.uri}
                    media={socialData.image}
                    description={socialData.pinterest}
                    onPin={onPinterestPin}
                    iconType={iconType}
                    connectAccounts={pinterestConnectAccounts}
                    viewer={viewer}
                    user={user}
                    item={itemData}
                />
                <PdpFacebookIcon iconType={props.iconType} />
                {/*
                    enable_pdp_stf: easy way to disable send to
                    friend functionality in case if spammers
                    start to hit this functionality heavily
                    possible long-term solution: create a thin
                    node-app route that the modal POSTs to instead
                    to allow for better obfuscation to sending emails
                */}
                {enabler.isEnabled('enable_pdp_stf') &&
                    <PdpEmailIcon
                        relay={props.relay}
                        selectedItems={props.selectedItems}
                        iconType={props.iconType}
                    />
                }
                {this._getPrintIcon()}
            </div>
        );
    }
}

PdpSocialIcons.propTypes = {
    socialData: PropTypes.object.isRequired,
    onPinterestPin: PropTypes.func,
    pinterestConnectAccounts: PropTypes.bool,
    printIcon: PropTypes.bool,
    iconType: PropTypes.string,
    relay: PropTypes.object,
    selectedItems: PropTypes.array,
    viewer: PropTypes.object,
    user: PropTypes.object,
    itemData: PropTypes.object,
    isPinterestModalShown: PropTypes.bool,
};

PdpSocialIcons.defaultProps = {
    printIcon: true,
};

module.exports = connectToStores(
    createFragmentContainer(PdpSocialIcons, {
        viewer: graphql`
            fragment PdpSocialIcons_viewer on Viewer {
                ...PinterestPinIcon_viewer
            }
        `,
        user: graphql`
            fragment PdpSocialIcons_user on User {
                ...PinterestPinIcon_user
            }
        `,
    }),
    [PdpUiStore],
    context => {
        const uiStore = context.getStore(PdpUiStore);
        return { isPinterestModalShown: uiStore.getIsPinterestModalShown() };
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/PdpSocialIcons.jsx